import React from "react";

const DEFAULT_BANNER = "/assets/images/betteritservice/success-stories-banner.jpg";

const ServicesBanner = ({
  title,
  description,
  caseStudyLink,
  heroImage,
  compactMode,
}) => {
  const bannerImage = heroImage || DEFAULT_BANNER;

  return (
    <div className="w-full relative bg-white">

      {/* Hero Banner */}
      <div
        className="relative w-full"
        style={{
          backgroundImage: `url(${bannerImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "clamp(200px, 15vw, 280px)",
        }}
      >
        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: "linear-gradient(to bottom right, #0E668FCC, #0B2142EE)",
          }}
        />

        {/* Title Box */}
        <div
          className="absolute"
          style={{
            top: "clamp(12px, 3vw, 28px)",
            left: "clamp(16px, 4vw, 68px)",
            background: "linear-gradient(to bottom, #1694CE, #071326)",
            padding: "clamp(12px, 2vw, 24px) clamp(16px, 3vw, 35px)",
            maxWidth: "clamp(200px, 65vw, 800px)",
          }}
        >
          <h2
            className="text-white font-bold font-montserrat m-0"
            style={{ fontSize: "clamp(16px, 2.8vw, 42px)" }}
          >
            {title}
          </h2>
        </div>
      </div>

      {/* Description Box — only if passed */}
      
      {description && (
        <div className="relative w-[95%] sm:w-[90%] bg-white shadow-md -mt-[100px] sm:-mt-[60px] mx-auto border mb-10">
          <div className="px-0 py-6 sm:py-[24px] w-full">
            <p className="text-[#333333] text-[14px] sm:text-[16px] leading-[22px] sm:leading-[24px] font-normal font-inter mb-4 w-full px-4 sm:px-[45px]">
              {description}
            </p>
          </div>
        </div>
      )}


    </div>
  );
};

export default ServicesBanner;